import firebase from "firebase/compat/app";
import formatUserData from "../utils/formatUserData";

const getUserInfoByUserId = async function(id) {
  let db = firebase.firestore();
  //get member infomation in each group
  const userSnapshot = await db
    .collection("wellness_users")
    .doc(id)
    .get();
  return formatUserData(id, userSnapshot.data());
};
export default getUserInfoByUserId;
